export enum RunProcessComponentDropDownItems {
    RunBookCostCalc = "Run Book Cost Calculation",
    RunInterception = "Run Interception"
}